import { Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';

@Component({
  selector: 'app-networks',
  templateUrl: './networks.component.html',
  styleUrls: ['./networks.component.css']
})
export class NetworksComponent {
    constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  toggleSection(sectionId: string, show: boolean): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const section = document.getElementById(sectionId);
    const moreBtn = document.getElementById(`${sectionId}_more_btn`);
    const lessBtn = document.getElementById(`${sectionId}_less_btn`);

    if (section && moreBtn && lessBtn) {
      section.style.display = show ? 'block' : 'none';
      moreBtn.style.display = show ? 'none' : 'flex';
      lessBtn.style.display = show ? 'flex' : 'none';
    }
  }

  ngAfterViewInit(): void {
  if (isPlatformBrowser(this.platformId)) {
    import('aos').then(AOS => {
      AOS.default.init({
        duration: 1000,
        once: true
      });
    });
  }
}

}
